document.addEventListener('DOMContentLoaded', function () {
    const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');

    addToCartForms.forEach(function (form) {
      form.addEventListener('submit', function () {
        setTimeout(function () {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              const cartTotal = cart.total_price / 100;
              if (cartTotal > 100) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'high_value_add_to_cart',
                  value: cartTotal
                });
                console.log('Custom event triggered: high_value_add_to_cart');
              }
            });
        }, 1000); // slight delay to allow cart to update
      });
    });
  });



document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (event) {
    if (event.target.closest('.checkout.wsFbtBundleDisc.cart__checkout')) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartTotal = cart.total_price / 100;
          let totalCost = 0;

          cart.items.forEach(item => {
            const variantId = item.variant_id;
            const costPrice = window.variantCostData?.[variantId] || 0;
            totalCost += costPrice * item.quantity;
          });

          const marginValue = cartTotal - totalCost;
          const marginPercent = (marginValue / cartTotal) * 100;

          if (cartTotal > 100) {
            window.dataLayer.push({
              event: 'high_value_begin_checkout',
              value: cartTotal.toFixed(2),
              margin_value: marginValue.toFixed(2),
              margin_percent: marginPercent.toFixed(2)
            });

          
          }
        });
    }
  });
});







